import type { FormEvent } from 'react';
import React from 'react';

import { FormField, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models/index';
import { BED_BUGS } from '../../../constants';
import YesAndNoExpansion from '../../Widgets/YesAndNoExpansion';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function BedBugs({ section, setSectionValues }: Props) {
  function onBedBugsYesClick(): void {
    setSectionValues({
      [BED_BUGS.FIELD_NAME.IS_ENABLED]: true,
    });
  }

  function onBedBugsNoClick(): void {
    setSectionValues({
      [BED_BUGS.FIELD_NAME.IS_ENABLED]: false,
    });
  }

  function onDescriptionChange(event: FormEvent<HTMLInputElement>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [BED_BUGS.FIELD_NAME.DESCRIPTION]: value,
    });
  }

  const bedBugsEnabled = section.getFieldValue(BED_BUGS.FIELD_NAME.IS_ENABLED);

  return (
    <FormField
      label={<Label size="lg">Within the last 120 days, has there been any history of bed bug infestation?</Label>}
      control={
        <YesAndNoExpansion yesHandler={onBedBugsYesClick} noHandler={onBedBugsNoClick} yesActive={bedBugsEnabled}>
          <FormField
            label={<Label>Describe where and when</Label>}
            control={
              <Textarea
                onChange={onDescriptionChange}
                value={section.getFieldValue(BED_BUGS.FIELD_NAME.DESCRIPTION)}
                resize="vertical"
                disabled={section.isFieldDisabled(BED_BUGS.FIELD_NAME.DESCRIPTION)}
              />
            }
          />
        </YesAndNoExpansion>
      }
    />
  );
}
